import script from "./open-voting-button.vue?vue&type=script&lang=js"
export * from "./open-voting-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__